import React from 'react';
import { Button } from "../ui/button";
import { ExternalLink, PlayCircle } from 'lucide-react';

const VideoPreview = ({ videoId, title }) => (
  <div className="relative aspect-video w-full rounded-lg overflow-hidden bg-gray-100">
    <img
      src={`https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`}
      alt={title}
      className="w-full h-full object-cover"
    />
    <div className="absolute inset-0 flex items-center justify-center">
      <PlayCircle className="w-16 h-16 text-white opacity-80" />
    </div>
    <a
      href={`https://www.youtube.com/watch?v=${videoId}`}
      target="_blank"
      rel="noopener noreferrer"
      className="absolute inset-0"
    >
      <span className="sr-only">Watch {title}</span>
    </a>
  </div>
);

const GuidanceSection = ({ guidance, title }) => {
  if (!guidance) return null;

  return (
    <div className="space-y-6">
      <h4 className="font-medium text-lg">What's Next?</h4>
      
      {/* Next Steps */}
      <div className="prose max-w-none">
        <div className="whitespace-pre-line text-gray-600">
          {guidance.nextSteps}
        </div>
      </div>

      {/* Video Guide */}
      {guidance.videoId && (
        <div>
          <h4 className="font-medium mb-2">Watch Our Guide</h4>
          <VideoPreview 
            videoId={guidance.videoId} 
            title={`${title} Compliance Guide`}
          />
        </div>
      )}

      {/* Call to Action */}
      {guidance.ctaUrl && (
        <Button
          className="w-full"
          variant="outline"
          onClick={() => window.open(guidance.ctaUrl, '_blank')}
        >
          {guidance.ctaText || "Learn More"} <ExternalLink className="ml-2 h-4 w-4" />
        </Button>
      )}
    </div>
  );
};

export default GuidanceSection;
